import React, { useState } from 'react';
import { PlusIcon, SettingsIcon, PackageIcon, UsersIcon, LockIcon } from 'lucide-react';
import { BUSINESSES } from '../data';
export function Admin() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [activeTab, setActiveTab] = useState('verksamheter');
  if (!isLoggedIn) {
    return <div className="flex min-h-screen items-center justify-center bg-warm px-6 pt-20" data-id="element-221" data-mp="34958dnksbd8p">
        <div className="w-full max-w-md rounded-sm border border-brun/10 bg-beige p-10 shadow-2xl shadow-brun/5" data-id="element-222" data-mp="26nrchk702kh4">
          <div className="mb-8 flex justify-center" data-id="element-223" data-mp="2bmb1jtgw4cdp">
            <div className="flex h-16 w-16 items-center justify-center rounded-full bg-skog/10 text-skog" data-id="element-224" data-mp="2gl5g2j7tres0">
              <LockIcon className="h-8 w-8" data-id="element-225" data-mp="2lki59am64xxr" />
            </div>
          </div>
          <h1 className="text-center font-display text-3xl text-brun" data-id="element-226" data-mp="3s018d7ze9er1">Logga in</h1>
          <p className="mt-2 text-center text-sm text-brun-soft" data-id="element-227" data-mp="3s258deu69tm1">Adminpanel för Smaken som Baken</p>
          
          <form className="mt-8 space-y-5" onSubmit={e => {
          e.preventDefault();
          setIsLoggedIn(true);
        }} data-id="element-228" data-mp="vkk22vi4zsp">
            <div data-id="element-229" data-mp="3fprxy0ilvaa5">
              <label className="mb-2 block text-[11px] uppercase tracking-wide2 text-brun-soft" data-id="element-230" data-mp="3fp8bq7lx9zqb">E-postadress</label>
              <input type="email" required placeholder="admin@smakensombaken.se" className="w-full rounded-sm border border-brun/20 bg-white p-4 text-brun outline-none transition-colors focus:border-skog" data-id="element-231" data-mp="3bp80evu4e4nh" />
            </div>
            <div data-id="element-232" data-mp="2ww4jmqocruxt">
              <label className="mb-2 block text-[11px] uppercase tracking-wide2 text-brun-soft" data-id="element-233" data-mp="2rz4cecfrom54">Lösenord</label>
              <input type="password" required placeholder="••••••••" className="w-full rounded-sm border border-brun/20 bg-white p-4 text-brun outline-none transition-colors focus:border-skog" data-id="element-234" data-mp="2ny2jsegcv8c4" />
            </div>
            <button type="submit" className="mt-4 w-full rounded-sm bg-skog py-4 text-sm uppercase tracking-wide2 text-warm transition-colors hover:bg-brun" data-id="element-235" data-mp="24c0np05fk9py">
              Logga in
            </button>
          </form>
        </div>
      </div>;
  }
  return <div className="flex min-h-screen bg-warm pt-20" data-id="element-236" data-mp="1zc4ln6gamsd1">
      {/* Sidebar */}
      <aside className="w-64 border-r border-brun/10 bg-beige p-6" data-id="element-237" data-mp="2n28mj623ke0c">
        <h2 className="font-display text-xl text-brun" data-id="element-238" data-mp="2n30jak7fkhs7">Admin</h2>
        <nav className="mt-10 space-y-2" data-id="element-239" data-mp="2s1lc3ykcrz6m">
          <button onClick={() => setActiveTab('verksamheter')} className={`flex w-full items-center gap-3 rounded-sm px-4 py-3 text-sm transition-colors ${activeTab === 'verksamheter' ? 'bg-skog text-warm' : 'text-brun-soft hover:bg-brun/5'}`} data-id="element-240" data-mp="2s3egt8beo9bz">
            <PackageIcon className="h-4 w-4" data-id="element-241" data-mp="360l157bs2g3b" />
            Verksamheter
          </button>
          <button onClick={() => setActiveTab('orders')} className={`flex w-full items-center gap-3 rounded-sm px-4 py-3 text-sm transition-colors ${activeTab === 'orders' ? 'bg-skog text-warm' : 'text-brun-soft hover:bg-brun/5'}`} data-id="element-242" data-mp="3ascqjej76frv">
            <UsersIcon className="h-4 w-4" data-id="element-243" data-mp="ucy9j4bn879m" />
            Förfrågningar
          </button>
          <button onClick={() => setActiveTab('settings')} className={`flex w-full items-center gap-3 rounded-sm px-4 py-3 text-sm transition-colors ${activeTab === 'settings' ? 'bg-skog text-warm' : 'text-brun-soft hover:bg-brun/5'}`} data-id="element-244" data-mp="191m16zidbwua">
            <SettingsIcon className="h-4 w-4" data-id="element-245" data-mp="gg2mu92gyhb3" />
            Inställningar
          </button>
        </nav>
        
        <div className="absolute bottom-6 left-6" data-id="element-246" data-mp="bh81azd4aena">
          <button onClick={() => setIsLoggedIn(false)} className="text-sm text-brun-soft hover:text-terrakotta" data-id="element-247" data-mp="pffxh52bxbxe">
            Logga ut
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 p-10" data-id="element-248" data-mp="20s8lq5vwvi8p">
        {activeTab === 'verksamheter' && <div data-id="element-249" data-mp="1wr6lpmu6725o">
            <div className="flex items-center justify-between" data-id="element-250" data-mp="1wrool2bc8emk">
              <h1 className="font-display text-3xl text-brun" data-id="element-251" data-mp="2s2wp5wwejzgq">Hantera Verksamheter</h1>
              <button className="flex items-center gap-2 rounded-sm bg-skog px-5 py-2.5 text-sm text-warm hover:bg-brun" data-id="element-252" data-mp="2w3q7mar2sm28">
                <PlusIcon className="h-4 w-4" data-id="element-253" data-mp="3121jss4uf8nm" />
                Lägg till ny
              </button>
            </div>

            <div className="mt-10 overflow-hidden rounded-sm border border-brun/10 bg-white" data-id="element-254" data-mp="362z3j95i4ar8">
              <table className="w-full text-left text-sm" data-id="element-255" data-mp="3b0hdn2v98w0t">
                <thead className="border-b border-brun/10 bg-beige/50 text-brun-soft" data-id="element-256" data-mp="3f2m5bw257ikt">
                  <tr data-id="element-257" data-mp="3jtkk2r7hg8ly">
                    <th className="p-4 font-medium" data-id="element-258" data-mp="3jt2jxjhp9a8r">Namn</th>
                    <th className="p-4 font-medium" data-id="element-259" data-mp="3jvx0gzxleaww">Kategorier</th>
                    <th className="p-4 font-medium" data-id="element-260" data-mp="3orcfvwb90evf">Status</th>
                    <th className="p-4 font-medium" data-id="element-261" data-mp="3tsa52suoe96f">Åtgärd</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-brun/5" data-id="element-262" data-mp="2knvykp6tei6">
                  {BUSINESSES.map(b => <tr key={b.name} className="hover:bg-beige/30" data-id="element-263" data-mp="1n3rl3c1thq0y">
                      <td className="p-4 font-medium text-brun" data-id="element-264" data-mp="1i4et6cw39sri">{b.name}</td>
                      <td className="p-4 text-brun-soft truncate max-w-[200px]" data-id="element-265" data-mp="1i6hqzj3hgq6s">{b.services}</td>
                      <td className="p-4" data-id="element-266" data-mp="1d7el5wfoifxr">
                        <span className={`inline-flex rounded-full px-2 py-1 text-[10px] uppercase tracking-wide2 ${b.status === 'coming-soon' ? 'bg-smorgul/20 text-smorgul' : 'bg-skog/10 text-skog'}`} data-id="element-267" data-mp="186qy1lukmj8t">
                          {b.status === 'coming-soon' ? 'Kommande' : 'Aktiv'}
                        </span>
                      </td>
                      <td className="p-4" data-id="element-268" data-mp="1w2ldeq847u8p">
                        <button className="text-terrakotta hover:underline" data-id="element-269" data-mp="1r5cv8pmyvq7g">Redigera</button>
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </div>}

        {activeTab === 'orders' && <div data-id="element-270" data-mp="hw89p3tiz3ks">
            <h1 className="font-display text-3xl text-brun" data-id="element-271" data-mp="hvordlzyqd68">Inkomna förfrågningar</h1>
            <p className="mt-4 text-brun-soft" data-id="element-272" data-mp="mvbecn5lf7s8">Här visas leads från checkout-flödet.</p>
          </div>}
      </main>
    </div>;
}